import { styled } from '@mui/material';

import { DESKTOP_MIN_WIDTH } from '~/constants/common';
import { COLORS } from '~/styles/colors';

export const StyledShapesContainer = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    marginTop: '16px',
    [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
      flexWrap: 'nowrap',
      overflow: 'auto',
      overscrollBehavior: 'contain',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
  };
});

export const StyledShape = styled('button')<{ $isSelected?: boolean }>(({ $isSelected }) => {
  return {
    border: 'none',
    padding: '12px',
    backgroundColor: $isSelected ? COLORS.blue50 : COLORS.transparent,
    height: '60px',
    borderRadius: '16px',
    cursor: 'pointer',
  };
});

export const StyledInfo = styled('div')(() => {
  return {
    display: 'flex',
    gap: '8px',
    padding: '16px',
    border: `1px solid ${COLORS.grey200}`,
    backgroundColor: COLORS.grey500,
    borderRadius: '20px',
    marginTop: '20px',
  };
});

export const StyledShapeContainer = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '16px',
    backgroundColor: COLORS.lightGray,
    borderRadius: '20px',
    position: 'relative',
    border: `1px solid ${COLORS.grey200}`,
    marginTop: '12px',
  };
});

export const StyledGradientForm = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    gap: '16px',
    [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
      flexDirection: 'column',
    },
  };
});
